<script lang="ts" setup>
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const day = layoutData?.value?.promoBanner?.dayOfWeek
const deliveryPromise = computed(() => {
  const dpKey = Object.keys(layoutData?.value?.promoBanner?.deliveryPromise || {}).find(key => key.includes(`_${day}`))

  if (!dpKey || !layoutData?.value?.promoBanner?.deliveryPromise[dpKey]) {
    return ''
  }

  const [name, key] = dpKey.split('_')

  return {
    name,
    key,
    content: layoutData?.value?.promoBanner?.deliveryPromise[dpKey],
  }
})

const visibleBanners = computed(() => {
  return layoutData?.value?.promoBanner?.PromoBanners?.filter((banner) => {
    let x = true
    if (banner.DateFrom && banner.DateFrom > new Date().toISOString()) {
      x = false
    }
    if (banner.DateTo && banner.DateTo < new Date().toISOString()) {
      x = false
    }
    return x
  })?.map((banner) => {
    return {
      ...banner,
      Text: JSON.parse(JSON.stringify(banner.Text).replace('{dynamic-delivery-promise}', deliveryPromise.value.content || '')),
    }
  }).sort((a, b) => (a.Priority || 0) - (b.Priority || 0)) || []
})

const showPromoBanners = useSessionStorage('show_promo_banners', true, { initOnMounted: true })

const interval = ref(10000)
const bannerContent = ref()
const bannerIndex = ref(0)
let i = 0

const setActiveBanner = () => {
  bannerContent.value = visibleBanners.value[i]
  bannerIndex.value = i++

  i = i > visibleBanners.value?.length - 1 ? 0 : i
}

const { isActive } = useIntervalFn(() => {
  if (isActive.value) {
    setActiveBanner()
  }
}, interval)

function closePromoBanner() {
  showPromoBanners.value = !showPromoBanners.value
}

onMounted(() => {
  setActiveBanner()
})
</script>

<template>
  <div
    v-if="visibleBanners?.length && showPromoBanners"
    class="promo-banner"
    :class="{ active: bannerContent }"
  >
    <Transition name="fade">
      <AppPromoBannerItem
        v-if="bannerContent"
        :key="bannerIndex"
        :banner-content="bannerContent"
        @close="closePromoBanner"
      />
    </Transition>
  </div>
</template>

<style>
@import url("~layers/components/App/PromoBanner.css");
</style>
